import React from 'react';
import chickenGlueIcon from '../../../public/static/images/chicken+glue.png';
import dolphinIcon from '../../../public/static/images/dolphin.png';
import pixelPhone from '../../../public/static/images/pixelPhone.png';
import plainRainbow from '../../../public/static/images/plainRainbow.png';
import voteIcon from '../../../public/static/images/vote.png';

import { BFIslandButton, BFIslandColors } from '@buzzfeed/react-components';
import { RiffIcon } from '../../../icons/ChatIcons';

import {
  ConnectorOne,
  ConnectorThree,
  ConnectorTwo,
  PointingHand,
} from '../../../icons/LandingPageIcons';
import {
  DEMO_BASE_STEP_IMAGE,
  DEMO_FINAL_STEP_IMAGE,
  DEMO_MID_STEP_IMAGE,
  DEMO_VIDEO,
  ITUNES_APP_URL,
} from '../../../constants';
import { useMediaQuery } from '../../../hooks';
import ProgressDots from '../../ProgressDots';
import styles from './index.module.scss';

const STEPS = [
  {
    number: '1.',
    imageSrc: DEMO_BASE_STEP_IMAGE,
    imageClassName: styles.stepImageBase,
    action: 'riff',
  },
  {
    number: '2.',
    imageSrc: DEMO_MID_STEP_IMAGE,
    imageClassName: styles.stepImageOverlay,
    action: 'prompt',
    prompt: 'Replace bottle with parrot',
  },
  {
    number: '3.',
    imageSrc: DEMO_FINAL_STEP_IMAGE,
    imageClassName: styles.stepImageBase,
    action: 'prompt',
    prompt: 'Add pirate hats',
  },
];

const STEP_MASCOTS = [dolphinIcon, chickenGlueIcon, voteIcon];
const STEP_CONNECTORS = [
  {
    Component: ConnectorOne,
    className: styles.stepConnector1,
  },
  {
    Component: ConnectorTwo,
    className: styles.stepConnector2,
  },
  {
    Component: ConnectorThree,
    className: styles.stepConnector3,
  },
];

const DemoStep = ({ step, index }) => {
  const isRiffStep = step.action === 'riff';
  const mascotIcon = STEP_MASCOTS[index];

  const { Component: Connector, className: connectorClassName } =
    STEP_CONNECTORS[index];

  return (
    <div className={styles.stepColumn}>
      <div className={styles.stepNumberAndMascot}>
        <span className={styles.stepNumber}>{step.number}</span>
        <div className={styles.stepMascot} aria-hidden>
          {mascotIcon && <img src={mascotIcon} alt="" />}
        </div>
      </div>
      <div className={styles.stepCard}>
        <div className={`${styles.stepConnector} ${connectorClassName}`}>
          <Connector />
        </div>
        <div className={styles.stepImageWrap}>
          <img
            className={step.imageClassName}
            src={step.imageSrc}
            alt=""
            aria-hidden
          />
        </div>
      </div>
      {isRiffStep && (
        <div className={styles.riffButton} aria-hidden>
          <RiffIcon /> <span>Riff</span>
          <div className={styles.hand} aria-hidden>
            <PointingHand />
          </div>
        </div>
      )}
      {!isRiffStep && (
        <div className={styles.promptBubble}>
          <p className={styles.promptText}>{step.prompt}</p>
        </div>
      )}
    </div>
  );
};

const DemoSection = () => {
  const { breakpoint, isLargeScreen } = useMediaQuery();

  const handleStartRiffingClick = () => {
    window.open(`${ITUNES_APP_URL}?pt=329394&ct=start_riffing&mt=8`, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className={styles.section}>
      <div className={styles.demoSection}>
        <header className={styles.demoHeader}>
          <h2 className={styles.title}>
            <span className={styles.titleAccent}>BF Island</span>. The app where
            you riff <br /> on your friends’ lives.
          </h2>
          <p className={styles.description}>
            Take a photo, start a riff, and cook up inside jokes that a “lol”
            can’t capture. No bots, just your group chat getting weirder!
          </p>
        </header>
        <div className={styles.railViewport}>
          <div className={styles.rail}>
            {STEPS.map((step, index) => (
              <DemoStep key={step.number} step={step} index={index} />
            ))}
          </div>
        </div>
        {breakpoint && !isLargeScreen && (
          <ProgressDots count={3} activeIndex={0} className={styles.demoDots} />
        )}
      </div>
      <div id="get-ready-to-explore" className={styles.outroSection}>
        <p className={styles.outroText}>
          Get ready to explore a whole new world of joyful, AI-powered
          creativity.
        </p>
        <div className={styles.outroArt}>
          <img
            src={plainRainbow}
            alt=""
            aria-hidden
            className={styles.outroRainbow}
          />
          <div className={styles.outroPhoneScreen}>
            <video
              className={styles.phoneVideo}
              autoPlay
              loop
              muted
              playsInline
              aria-hidden
            >
              <source src={DEMO_VIDEO} type="video/mp4" />
            </video>
            <img
              src={pixelPhone}
              alt=""
              aria-hidden
              className={styles.phoneImg}
            />
          </div>
        </div>
      </div>
      <div className={styles.ctaSection}>
        <div className={styles.ctaCopy}>
          <p className={styles.ctaTitle}>Remember when the internet was fun?</p>
          <p className={styles.ctaDescription}>
            Take a trip to BF Island and relive the good times.
          </p>
        </div>
        <BFIslandButton
          onClick={handleStartRiffingClick}
          text="Start riffing"
          size="medium"
          bgColor={BFIslandColors.LIME}
          width="203px"
        />
      </div>
    </section>
  );
};

export default DemoSection;